var jade = require("/build/customer-ui/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<cui-modal toggle=\"toggle\" modal-title=\"CREATE ACCOUNT\" type=\"account\"><register-form redirecting=\"redirecting\"><div class=\"form-group text-center\"><span class=\"form-text\">Have an account?<a href=\"\" ng-click=\"toggleLogin()\"> Sign in</a></span></div></register-form></cui-modal>");;return buf.join("");
}


// WEBPACK FOOTER //
// ./source/client/layout-components/account/register/register-modal.jade